import styled from 'styled-components'

export const StyledNewsSharedArticleViewAll = styled.div``
